/**
 * Mention related getters that operate on a "flat" json structure (requires the basic getters and the asset getters).
 */
function getters(options) {
  return {
    /**
     * Return an array of mention objects for all nodes of a structure (excluding recursive containers)
     * @return  {Array}   The mention objects
     */
    getMentions(state, getters, rootState, rootGetters) {
      const mentions = Object.keys(state.byId)
        .filter(id => !getters.getIsRecursiveContainer(id)) // exclude any recursive containers
        .map(id => {
          return getters.getMention(id);
        });
      return mentions;
    },

    /**
     * Return a mention object for a specific node
     * @param   {String} id The node id for which to return the mention
     * @return  {Object}    The mention object
     */
    getMention(state, getters, rootState, rootGetters) {
      return id => {
        const node = getters.getNode(id);
        if (!node) {
          return null;
        }
        const coverId = getters.getCoverId(node.id);
        return {
          mention_image: rootGetters['project/data/assets/getSmallImageUrl'](
            coverId
          ),
          mention_icon: getters.getCoverIcon(coverId) || getters.getDefaultIcon,
          mention_name: node.name ? node.name : node.title,
          mention_type: options.mentionType,
          mention_id: node.id,
        };
      };
    },
  };
}

export default { getters };
